import React, { useState } from "react";
import styled from "styled-components";

import Dropdown, { DropdownContainer, DropdownItem } from "./Dropdown";
import Icon, { ClickableIcon } from "./Icon";
import _theme from "../styles/theme";

const RemoveCourse = styled.div`
  color: ${({ theme }) => theme.color.primary};
`;

type CourseDropdownProps = {
  course: { [key: string]: any };
  stages: { [key: string]: any };
  openInfoModal: (x: any) => void;
  openDropModal: (x: any, e?: any) => void;
  openWithdrawModal: (x: any, e?: any) => void;
};

const CourseDropdown = ({
  course,
  stages,
  openInfoModal,
  openDropModal,
  openWithdrawModal,
}: CourseDropdownProps) => {
  const [isOpen, setOpen] = useState<boolean>(false);
  return (
    <DropdownContainer>
      <ClickableIcon
        ml={0.5}
        size={2}
        name="more-vertical"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!isOpen);
        }}
        style={{ color: _theme.color.primary }}
      />
      <Dropdown
        open={isOpen}
        style={{ whiteSpace: "nowrap" }}
        setOpen={setOpen}
        align="right"
      >
        <DropdownItem
          to="#"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(false);
            openInfoModal(course);
          }}
        >
          <Icon mr={1} name="info" /> Course Info
        </DropdownItem>
        {stages.dropnoW && (
          <DropdownItem
            to="#"
            onClick={(e: any) => {
              setOpen(false);
              openDropModal(course, e);
            }}
          >
            <RemoveCourse>
              <Icon mr={1} name="trash" /> Drop course
            </RemoveCourse>
          </DropdownItem>
        )}
        {stages.dropwithW && (
          <DropdownItem
            to="#"
            onClick={(e: any) => {
              setOpen(false);
              openWithdrawModal(course, e);
            }}
          >
            <RemoveCourse>
              <Icon mr={1} name="trash-empty" /> Withdraw course
            </RemoveCourse>
          </DropdownItem>
        )}
      </Dropdown>
    </DropdownContainer>
  );
};

export default CourseDropdown;
